import { Component, Input, Output, OnInit } from 'angular-ts-decorators';

import { Moment } from '@shared/app/scripts/vendor/moment';
import { SwChange } from '../../classes/sw-change';

/**
 * Component to input date time value.
 *
 * # Example
 * <pre>
 *   <sw-date-time-picker></sw-date-time-picker>
 * </pre>
 *
 * # Attributes
 * * sw-value - value to init the component
 * * sw-change - callback that will be called with value
 * * default-hour - string in HH:MM format with hour we want to set by when
 * resetting
 */
@Component({
  selector: 'swDateTimePicker',
  template: require('./sw-date-time-picker.html').default,
})
export class SwDateTimePickerComponent extends SwChange implements OnInit {
  @Input() value: Date;
  @Input('@') defaultHour: string;

  @Output() swChange: (value?: Date) => any;

  constructor(private moment: Moment) {
    'ngInject';

    super();
  }

  // Note! It's different model, because according to uib-timepicker doc:
  // > This component should not be used with the same model as the datepicker.
  // https://angular-ui.github.io/bootstrap/#timepicker
  hour: Date;

  ngOnInit() {
    if (angular.isDate(this.value)) {
      this.hour = this.value;
    }
  }

  setHour(time: Date) {
    const timeMoment = this.moment(time),
      hour = timeMoment.hour(),
      minute = timeMoment.minute();

    this.value = this.moment(this.value).minute(minute).hour(hour).toDate();

    this.change(this.value);
  }

  resetHour() {
    if (
      this.defaultHour &&
      this.moment(this.defaultHour, 'HH:mm', true).isValid()
    ) {
      this.hour = this.moment(this.defaultHour, 'HH:mm').toDate();
    } else {
      this.hour = this.moment('12:00', 'HH:mm').toDate();
    }

    this.setHour(this.hour);
  }

  setDate(date: Date) {
    this.value = date;
    this.resetHour();
  }
}
